import { render, staticRenderFns } from "./ExportPermissions.vue?vue&type=template&id=175963cb"
import script from "./ExportPermissions.vue?vue&type=script&lang=js"
export * from "./ExportPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports